import { useCallback, useEffect, useState } from "react";
import { Token, tokens } from "./data";
import TokenIconButton from "./tokenIconButton";
import { Chains } from "./data";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { selectChain } from "../features/chain";
import { selectToken, setPlaceholder, setToken } from "../features/token";
import { selectBuyMode, setAmount } from "../features/trade";
export type TokenSelectorType = {

}

const TokenSelector = (): JSX.Element => {
    const [openList, setOpenList] = useState(false);
    const chain = useAppSelector(selectChain);
    const token = useAppSelector(selectToken);
    const buyMode = useAppSelector(selectBuyMode);
    const dispatch = useAppDispatch();

    const getFirstValidTokenId = useCallback((): number => {
        for (let i = 0; i < tokens.length; i++) {
            if (Chains[chain].wbtcAddr[i].addr !== '') {
                return i;
            }
        }
        return 0;
    }, [chain]);
    const swtichToken = useCallback((token: Token) => {
        dispatch(setToken(token));
        dispatch(setAmount(''));
        if (buyMode)
            dispatch(setPlaceholder(tokens[token][0]));
        else
            dispatch(setPlaceholder('FACE'));
    }, [buyMode, dispatch])
    useEffect(() => {
        setOpenList(false);
        swtichToken(getFirstValidTokenId());
    }, [chain, getFirstValidTokenId, swtichToken]);

    function toggleList() {
        setOpenList(!openList);
    }

    useEffect(() => {
        document.addEventListener('click', (e) => {
            setOpenList(false);
        })
    }, []);

    return (
        <>
            {openList &&
                <div className="bg-[#595959] rounded-full p-1 relative z-50">
                    <ul className='text-white flex flex-col gap-2'>
                        <li><button className="flex items-center gap-2 w-6 md:w-8 h-6 md:h-8"
                            onClick={(e) => {
                                toggleList();
                                e.nativeEvent.stopImmediatePropagation();
                            }}>
                            <img className="w-6 md:w-8 h-6 md:h-8" src={tokens[token][1]} alt="" />
                            {/* <span className=" text-lg">{tokens[token][0]}</span> */}
                        </button>
                        </li>

                    </ul>
                </div>
            }
            {!openList &&
                <div className="text-white p-1">
                    <button className="flex items-center gap-2 w-6 md:w-8 h-6 md:h-8"
                        onClick={(e) => {
                            toggleList();
                            e.nativeEvent.stopImmediatePropagation();
                        }}>
                        <img className="w-6 md:w-8 h-6 md:h-8" src={tokens[token][1]} alt="" />
                    </button>
                </div>

            }
        </>);
}

export default TokenSelector;